<template>
  <div class="card">
    <header class="card-header">
      <p class="card-header-title">Worker Satisfaction</p>
    </header>
    <div class="card-content">
      <div class="content">
        <div v-if="!productData.d13">No data available</div>
        <div v-for="factory  in productData.d13" :key="factory.d13_factoryId" class="factory">
          <p class="text-body">{{factory.d13_factoryName}}</p>
          <div class="rating">
            <div class>
              <figure class="image">
                <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'smiley'" :class="{smiley:true,active:factory.d13_workerSatisfactionScore === 1}" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="#586673"><path d="M15 13a2 2 0 11-4 0 2 2 0 014 0zM27 13a2 2 0 11-4 0 2 2 0 014 0z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19 22.75c-4.246 0-7.86 2.893-9.341 5.61a.75.75 0 11-1.317-.72c1.692-3.101 5.761-6.39 10.658-6.39 2.453 0 4.774.827 6.643 2.028 1.862 1.195 3.336 2.8 4.044 4.422a.75.75 0 11-1.374.6c-.562-1.287-1.802-2.682-3.48-3.76-1.67-1.072-3.714-1.79-5.833-1.79z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19 36.5c9.665 0 17.5-7.835 17.5-17.5S28.665 1.5 19 1.5 1.5 9.335 1.5 19 9.335 36.5 19 36.5zm0 1.5c10.493 0 19-8.507 19-19S29.493 0 19 0 0 8.507 0 19s8.507 19 19 19z"/></g></svg>
              </figure>
            </div>

            <div class>
              <figure class="image">
                <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'smiley'" :class="{smiley:true,active:factory.d13_workerSatisfactionScore === 2}" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="#586673"><path d="M15 13a2 2 0 11-4 0 2 2 0 014 0zM27 13a2 2 0 11-4 0 2 2 0 014 0z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M11.773 22.818a.75.75 0 01.91-.545l14 3.5a.75.75 0 01-.365 1.455l-14-3.5a.75.75 0 01-.545-.91z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19 36.5c9.665 0 17.5-7.835 17.5-17.5S28.665 1.5 19 1.5 1.5 9.335 1.5 19 9.335 36.5 19 36.5zm0 1.5c10.493 0 19-8.507 19-19S29.493 0 19 0 0 8.507 0 19s8.507 19 19 19z"/></g></svg>
              </figure>
            </div>

            <div class>
              <figure class="image">
                <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'smiley'" :class="{smiley:true,active:factory.d13_workerSatisfactionScore === 3}" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="#586673"><path d="M15 13a2 2 0 11-4 0 2 2 0 014 0zM27 13a2 2 0 11-4 0 2 2 0 014 0z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10.25 23a.75.75 0 01.75-.75h16a.75.75 0 010 1.5H11a.75.75 0 01-.75-.75z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19 36.5c9.665 0 17.5-7.835 17.5-17.5S28.665 1.5 19 1.5 1.5 9.335 1.5 19 9.335 36.5 19 36.5zm0 1.5c10.493 0 19-8.507 19-19S29.493 0 19 0 0 8.507 0 19s8.507 19 19 19z"/></g></svg>
              </figure>
            </div>

            <div class>
              <figure class="image">
                <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" :class="{smiley:true,active:factory.d13_workerSatisfactionScore === 4}" v-bind:class="'smiley'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="#586673"><path d="M15 13a2 2 0 11-4 0 2 2 0 014 0zM27 13a2 2 0 11-4 0 2 2 0 014 0z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9.783 22.75h18.434c-.376 4.187-3.892 7.5-9.217 7.5-5.325 0-8.841-3.313-9.217-7.5zM8.25 22c0 5.466 4.39 9.75 10.75 9.75S29.75 27.466 29.75 22a.75.75 0 00-.75-.75H9a.75.75 0 00-.75.75z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19 36.5c9.665 0 17.5-7.835 17.5-17.5S28.665 1.5 19 1.5 1.5 9.335 1.5 19 9.335 36.5 19 36.5zm0 1.5c10.493 0 19-8.507 19-19S29.493 0 19 0 0 8.507 0 19s8.507 19 19 19z"/></g></svg>
              </figure>
            </div>

            <div class>
              <figure class="image">
                <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'smiley'" :class="{smiley:true,active:factory.d13_workerSatisfactionScore === 5}" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="#586673"><path fill-rule="evenodd" clip-rule="evenodd" d="M19 28.25c4.246 0 7.86-2.893 9.341-5.61a.75.75 0 111.317.72C27.966 26.46 23.897 29.75 19 29.75c-2.453 0-4.774-.827-6.643-2.028-1.862-1.195-3.336-2.8-4.045-4.422a.75.75 0 111.375-.6c.562 1.287 1.802 2.682 3.48 3.76 1.67 1.072 3.714 1.79 5.833 1.79z"/><path d="M15 13a2 2 0 11-4 0 2 2 0 014 0zM27 13a2 2 0 11-4 0 2 2 0 014 0z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19 36.5c9.665 0 17.5-7.835 17.5-17.5S28.665 1.5 19 1.5 1.5 9.335 1.5 19 9.335 36.5 19 36.5zm0 1.5c10.493 0 19-8.507 19-19S29.493 0 19 0 0 8.507 0 19s8.507 19 19 19z"/></g></svg>
              </figure>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardWorkerSatisfaction",
  props: { productData: Object },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/scss/global.scss";

div.icon {
  // width: 100%;
  height: auto;
  margin: 0 0.25rem;
  // flex-basis: 20%;
  flex: 1;
}
.content figure {
  margin: 0;
}
.content figure img {
  margin: auto;
  width: 100%;
  // min-width: 36px;
  height: auto;
  // margin-bottom: 1rem;
}
.factory {
  margin-top: 0.5rem;
  &:first-child {
    margin-top: 0;
  }
}
.smiley {
  background: #eaeff6;
  padding: 4px;
  border-radius: 57px;
  height: 48px;
  width: 48px;
  &.active {
    background: linear-gradient(90deg, #30ac78 -3.35%, #3bc98d 100%);
    path {
      fill: #fff;
    }
  }
}
.rating {
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 2rem;
}
img {
  -webkit-filter: 0 12.5px 6.3px -60px rgba(0, 0, 0, 0.025),
    0 100px 50px -60px rgba(0, 0, 0, 0.05);
  filter: 0 12.5px 6.3px -60px rgba(0, 0, 0, 0.025),
    0 100px 50px -60px rgba(0, 0, 0, 0.05);
}

.content p:not(:last-child) {
  margin-bottom: 0.5rem;
}
</style>
